import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EditVisitComponent } from 'src/app/components/edit-visit/edit-visit.component';
import { CreateVisitComponent } from 'src/app/components/create-visit/create-visit.component';
import { VisitService } from 'src/app/services/visit/visit.service';
import { Visit } from 'src/app/services/interfaces/interfaces';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Session } from 'protractor';
import { AlertComponent } from 'src/app/components/common/alert/alert.component';

@Component({
  selector: 'app-visit',
  templateUrl: './visit.component.html',
  styleUrls: ['./visit.component.scss']
})

export class VisitComponent implements OnInit {

  dataSource = new MatTableDataSource<Visit[]>();
  session: Session;
  displayedColumns: string[] = [
    'id',
    'vis_fecha',
    'cli_nombre',
    'vis_cobranza',
    'vis_venta',
    'vis_cotizTipo',
    'vis_tipoContacto',
    'vis_problemas',
    'acciones'
  ];

  constructor(
    private visitService: VisitService,
    private dialog: MatDialog,
    private _snackBar: MatSnackBar
  ) { }

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  ngOnInit() {
    this.session = JSON.parse(sessionStorage.getItem('session'));
    this.load();
  }

  load() {
    this.visitService.get().subscribe((data) => {
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.dataSource.data = data['dsVisitas']['ttvisitas'];
      this.dataSource.data = this.sortArray(this.dataSource.data);
    });
  }

  openDialog(): void {
    let config: MatDialogConfig = {
      height: '650px',
      width: '850px'
    }
    this.dialog.open(CreateVisitComponent, config);
    this.dialog.afterAllClosed.subscribe(() => this.load());
  }

  openDelete(id: number): void {
    const dialogRef = this.dialog.open(AlertComponent, {
      width: '350px',
      data: "Los datos se perderán de forma permanente?"
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.delete(id);
      }
      this.load();
    });
  }

  delete(id: number): void {
    console.log(id, this.session['dsSesion']['ttsesion'][0]['nro']);
    this.visitService.delete(id, this.session['dsSesion']['ttsesion'][0]['nro']).subscribe((data) => {
      this.openSnackBar(data['ttResponse'][0]['ttMensaje'], 'Cerrar')
    })
    this.load();
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  edit(visit: Visit): void {
    let config: MatDialogConfig = {
      height: '650px',
      width: '850px',
      data: visit
    }
    this.dialog.open(EditVisitComponent, config);
  }

  /** Filter */
  applyFilter(filterValue: string): void {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }


  public sortArray(lecturas: any[]) {
    return lecturas.sort(function (a, b) {
      if (a.ID > b.ID) {
        return -1;
      }
      if (a.ID < b.ID) {
        return 1;
      }
      return 0;
    });
  }

}
